import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {withRouter} from "../withRouter";

class ManageGameLinks extends React.Component {
    handleSubmit(e) {
        e.preventDefault();

        const body = {
            'google_play': e.target.google_play.value ? e.target.google_play.value : null,
            'aptoide': e.target.aptoide.value ? e.target.aptoide.value : null,
            'amazon_app_store': e.target.amazon_app_store.value ? e.target.amazon_app_store.value : null,
            'galaxy_app_store': e.target.galaxy_store.value ? e.target.galaxy_store.value : null,

            'app_store': e.target.app_store.value ? e.target.app_store.value : null,
            'tweak_box': e.target.tweak_box.value ? e.target.tweak_box.value : null,
            'cydia': e.target.cydia.value ? e.target.cydia.value : null,

            'microsoft_store': e.target.microsoft_store.value ? e.target.microsoft_store.value : null,
            'steam': e.target.steam.value ? e.target.steam.value : null,
            'epic_games_store': e.target.epic_games_store.value ? e.target.epic_games_store.value : null,
        };

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/update/links', this.props.game.id.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then()
            .then(res => res.json())
            .then((response) => {
                console.log(response);
                console.log(JSON.stringify(body));
                window.location.reload(false);
            }, (error) => {
                console.log(error);
                window.location.reload(false);
            });
    }

    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <h2>Main</h2>
                    <input class="form-control" type="url" name="google_play" placeholder="Google Play" defaultValue={this.props.game.game_links ? this.props.game.game_links.google_play : ''}/>
                    <br/>
                    <input class="form-control" type="url" name="app_store" placeholder="App Store" defaultValue={this.props.game.game_links ? this.props.game.game_links.app_store : ''}/>
                    <br/>

                    <h2>Android</h2>
                    <input class="form-control" type="url" name="aptoide" placeholder="Aptoide" defaultValue={this.props.game.game_links ? this.props.game.game_links.aptoide : ''}/>
                    <br/>
                    <input class="form-control" type="url" name="amazon_app_store" placeholder="Amazon App Store" defaultValue={this.props.game.game_links ? this.props.game.game_links.amazon_app_store : ''}/>
                    <br/>
                    <input class="form-control" type="url" name="galaxy_store" placeholder="Galaxy Store" defaultValue={this.props.game.game_links ? this.props.game.game_links.galaxy_apps_store : ''}/>
                    <br/>

                    <h2>iOS</h2>
                    <input class="form-control" type="url" name="tweak_box" placeholder="Tweak Box" defaultValue={this.props.game.game_links ? this.props.game.game_links.tweak_box : ''}/>
                    <br/>
                    <input class="form-control" type="url" name="cydia" placeholder="Cydia" defaultValue={this.props.game.game_links ? this.props.game.game_links.cydia : ''}/>
                    <br/>

                    <h2>PC</h2>
                    <input class="form-control" type="url" name="steam" placeholder="Steam" defaultValue={this.props.game.game_links ? this.props.game.game_links.steam : ''}/>
                    <br/>
                    <input class="form-control" type="url" name="epic_games_store" placeholder="Epic Games Store" defaultValue={this.props.game.game_links ? this.props.game.game_links.epic_games_store : ''}/>
                    <br/>
                    <input class="form-control" type="url" name="microsoft_store" placeholder="Microsoft Store" defaultValue={this.props.game.game_links ? this.props.game.game_links.microsoft_store : ''}/>
                    <br/>

                    <input class="btn btn-success" type="submit" value="Save"/>
                </form>
            </div>
        );
    }
}

export default withRouter(ManageGameLinks);
